<template>
    <modal title="Postbox Einstellungen">
        <expansion-card>
            <template v-slot:header>
                <b>Wichtige Informationen</b>
            </template>
            Hier hast du je Vertragsnummer die Möglichkeit, die Zustellung in
            deine Postbox für die Zukunft abzuwählen. Dies hat zur Folge, dass
            du laufende Informationen zur abgewählten Vertragsnummer künftig in
            Papierform an die angegebene Zustelladresse erhältst. Du kannst die
            Zustellung in Papierform jederzeit für die Zukunft widerrufen.
        </expansion-card>
        <ion-list>
            <ion-item lines="full" class="u-size-medium">
                <ion-label><b>Bezeichnung (Vertragsnr.)</b></ion-label>
                <b slot="end">Postbox</b>
            </ion-item>
            <ion-item v-for="(entry, key) in entries" lines="full" :key="key">
                <ion-label class="u-size-medium">
                    {{ entry.Description }} ({{ entry.ProductIDFormatted }})
                </ion-label>
                <base-toggle
                    v-model="entries[key].ActiveForPostBox"
                    :id="key"
                ></base-toggle>
            </ion-item>
        </ion-list>
        <expansion-card>
            <template v-slot:header>
                <b>Benachrichtigungsintervall</b>
            </template>
            Verwalte das Benachrichtigungsintervall deiner Wüstenrot Produkte.
            Je nach Einstellung wirst du täglich, wöchentlich oder niemals per
            E-mail informiert, wenn eine neue Nachricht in der Postbox einlangt.
        </expansion-card>
        <base-select
            id="interval"
            v-model="interval"
            interfaceValue="alert"
            label="Benachrichtigungsintervall"
            :showLabel="false"
        >
            <ion-select-option value="DAILY">Täglich</ion-select-option>
            <ion-select-option value="WEEKLY">Wöchentlich</ion-select-option>
            <ion-select-option value="NEVER">Nie</ion-select-option>
        </base-select>
        <template v-slot:footer>
            <ion-button expand="block" @click="submitPostboxSettings()"
                >Speichern</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "./Modal";
import ExpansionCard from "./ExpansionCard";
import BaseToggle from "./BaseToggle";
import BaseSelect from "./BaseSelect";
import { setPostBoxSettings } from "@/api/postbox";

export default {
    components: {
        Modal,
        ExpansionCard,
        BaseToggle,
        BaseSelect,
    },
    props: {},
    data() {
        return {
            entries: {},
            interval: "",
        };
    },
    mounted() {
        this.fillPostboxSettings();
        this.$store.dispatch("postbox/getPostBoxSettings").then(() => {
            this.fillPostboxSettings();
        });
    },
    methods: {
        fillPostboxSettings() {
            const settings = this.$store.state.postbox.settings;
            if (settings.Entries) {
                this.entries = {};
                for (let entryKey in settings.Entries) {
                    let entry = { ...settings.Entries[entryKey] };
                    if (
                        settings.Entries[entryKey].ActiveForPostBox === "true"
                    ) {
                        entry.ActiveForPostBox = true;
                    } else {
                        entry.ActiveForPostBox = false;
                    }
                    this.$set(this.entries, entryKey, entry);
                }
            }
            if (settings.NotificationInterval) {
                this.interval = settings.NotificationInterval;
            }
        },
        submitPostboxSettings() {
            let data = {};
            for (let entryKey in this.entries) {
                data[entryKey] = this.entries[entryKey].ActiveForPostBox;
            }
            data.NotificationInterval = this.interval;
            this.$store.commit("setLoading", true);
            setPostBoxSettings(data).then((response) => {
                if (response.data.Status === 200) {
                    this.$store.dispatch("postbox/getPostBoxSettings");
                    this.$ionic.alertController
                        .create({
                            header: "Änderung erfolgreich",
                            message:
                                "Deine Postbox Einstellungen wurden erfolgreich geändert.",
                            buttons: ["Ok"],
                        })
                        .then((a) => {
                            a.onDidDismiss().then(() => {
                                this.$ionic.modalController.dismiss();
                            });
                            a.present();
                        });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
